import React from 'react';
import './Contact.css';

const Contact = () => {
    const [status, setStatus] = React.useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');

        const formData = new FormData(e.target);
        const object = Object.fromEntries(formData);
        const json = JSON.stringify(object);

        console.log("Sending email data:", object);

        try {
            const response = await fetch("https://formsubmit.co/ajax/cindy@pcpropertymgmt.com", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: json
            });

            const result = await response.json();
            console.log("Email API Response:", result);

            if (response.ok) {
                setStatus('success');
                e.target.reset();
            } else {
                setStatus('error');
            }
        } catch (error) {
            console.error("Email Error:", error);
            setStatus('error');
        }
    };

    // SVG Icon Components
    const EmailIcon = () => (
        <svg className="contact-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <rect x="12" y="18" width="40" height="28" rx="2" stroke="#FFFFFF" strokeWidth="2" />
            <path d="M12 20L32 34L52 20" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="32" cy="34" r="3" fill="#D4AF37" />
        </svg>
    );

    const PhoneIcon = () => (
        <svg className="contact-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <rect x="22" y="16" width="20" height="32" rx="2" stroke="#FFFFFF" strokeWidth="2" />
            <path d="M28 12H36" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" />
            <path d="M32 42H32.01" stroke="#D4AF37" strokeWidth="3" strokeLinecap="round" />
            <path d="M24 52L26 56L38 56L40 52" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const LocationIcon = () => (
        <svg className="contact-icon" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#0A192F" stroke="#D4AF37" strokeWidth="2" />
            <path d="M32 18C26.4772 18 22 22.4772 22 28C22 35.5 32 46 32 46C32 46 42 35.5 42 28C42 22.4772 37.5228 18 32 18Z" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="32" cy="28" r="3" fill="#D4AF37" />
            <ellipse cx="32" cy="50" rx="10" ry="3" fill="#D4AF37" fillOpacity="0.5" />
        </svg>
    );


    return (
        <div className="contact-page">
            <div className="page-header">
                <div className="container">
                    <h1>Contact Us</h1>
                    <p>We're here to help with your property management needs.</p>
                </div>
            </div>

            <div className="container section">
                <div className="contact-grid">

                    {/* Contact Info Sidebar */}
                    <div className="contact-info-sidebar">
                        <div className="info-block">
                            <EmailIcon />
                            <h3>Get In Touch</h3>
                            <p className="contact-label">Email</p>
                            <p><a href="mailto:cindy@pcpropertymgmt.com">cindy@pcpropertymgmt.com</a></p>

                            <p className="contact-label">Phone</p>
                            <PhoneIcon />
                            <p>+1 (226) 927-5757</p>
                        </div>

                        <div className="info-block">
                            <LocationIcon />
                            <h3>Our Locations</h3>
                            <div className="address-block">
                                <p><strong>London Office</strong></p>
                                <p>25 Alomar Drive<br />London, ON N6K 4X4</p>
                            </div>
                            <div className="address-block">
                                <p><strong>Markham Office</strong></p>
                                <p>43 Hendon Rd.<br />Markham, ON L3R 6Z6</p>
                            </div>
                        </div>
                    </div>

                    {/* Owner Inquiry Form */}
                    <div className="contact-form-container">
                        <h2>Send us a Message / Owner Inquiry</h2>
                        <p>Interested in our management services? Fill out the form below.</p>

                        <form className="contact-form" onSubmit={handleSubmit}>
                            {/* Hidden Configuration Fields for FormSubmit */}
                            <input type="hidden" name="_subject" value="New Website Inquiry" />
                            <input type="hidden" name="_cc" value="p.cpropservices@gmail.com" />
                            <input type="hidden" name="_captcha" value="false" />
                            <input type="hidden" name="_template" value="table" />

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="name">Full Name</label>
                                    <input type="text" id="name" name="name" required />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="email">Email Address</label>
                                    <input type="email" id="email" name="user_email" required />
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="phone">Phone Number</label>
                                <input type="tel" id="phone" name="phone" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="inquiryType">Inquiry Type</label>
                                <select id="inquiryType" name="inquiry_type">
                                    <option value="owner">Property Owner / Management Inquiry</option>
                                    <option value="tenant">Current Tenant</option>
                                    <option value="future">Future Resident</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Message</label>
                                <textarea id="message" name="message" rows="5" required></textarea>
                            </div>

                            <button type="submit" className="btn-primary" disabled={status === 'sending'}>
                                {status === 'sending' ? 'Sending...' : 'Send Message'}
                            </button>
                            {status === 'success' && <p className="success-message" style={{ color: 'green', marginTop: '10px' }}>Message sent successfully!</p>}
                            {status === 'error' && <p className="error-message" style={{ color: 'red', marginTop: '10px' }}>Failed to send message. Please try again.</p>}
                        </form>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Contact;
